import { LANGUAGE_CODES } from "@/i18n/config";
import { usePathname } from "next/navigation";

const useActivePath = () => {
  const pathname = usePathname();
  const activePath = pathname
    .split("/")
    .filter((segment) => segment && !LANGUAGE_CODES.includes(segment))
    .join("/");

  return activePath.startsWith("/") ? activePath : `/${activePath}`;
};

export default useActivePath;
